import { TipoComponentePersonalizacion } from '@/js/enums/customizations';
import { useAppConfigStore } from '@/js/stores/appConfig';
import APIErp from './APIErp';

/**
 * Comprueba si el formulario tiene el flag.
 * @param {string} frm - Formulario.
 * @param {string} flag - Flag.
 * @returns {boolean} `true` si tiene personalización, `false` en caso contrario.
 */
export function ExistePersonalizacionFlag(frm, flag) {
  const store = useAppConfigStore();
  return store.getPersonalizacionesFormularios.some((p) => p.Formulario === frm
    && p.ElementosPersonalizados.some(
      (ep) => ep.TipoComponente === TipoComponentePersonalizacion.Flag && ep.Valor === flag,
    ));
}

export default {

  /** *** Método ExistePersonalizacion */
  ExistePersonalizacion(frm, component) {
    let existePersonalizacion = false;

    const store = useAppConfigStore();
    const personalizaciones = store.getPersonalizacionesFormularios; // store.personalizacionesFormularios;

    if (personalizaciones != null) {
      personalizaciones.forEach((e) => {
        if (e.Formulario === frm) {
          e.ElementosPersonalizados.forEach((element) => {
            element.ComponentesDeAplicacion.forEach((componente) => {
              if (componente === component) {
                existePersonalizacion = true;
              }
            });
          });
        }
      });
    }
    return existePersonalizacion;
  },

  async ObtenerOperacionesPersonalizadasEntidadMultiple(lstEntidades, tipoEntidad, formulario, componenteDeAplicacion) {
    try {
      const consultaPersonalizacionApp = [];
      lstEntidades.forEach((e) => {
        consultaPersonalizacionApp.push({
          TipoEntidad: tipoEntidad,
          ComponenteDeAplicacion: componenteDeAplicacion,
          Formulario: formulario,
          Entidad: { Id: e.Id },
        });
      });
      const result = await APIErp.callObtenerOperacionesPersonalizadasEntidadMultiple(consultaPersonalizacionApp);
      if (result.data.Valor) {
        return JSON.parse(result.data.Mensaje);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
    return null;
  },

};
